
import { Product } from "@/types/product";

export const ircBT1: Product = {
  id: "irc-bt1",
  groupId: "avoip",
  name: "IRC-BT1",
  subtitle: "Bluetooth Audio Interface",
  description: "The IRC-BT1 is a RF/IR remote for controlling the VPX Series products. It will allow control of the channel mapping features to give a set top box feel in an AV over IP product. The remote will also give access to the EPG (Electronic Programming Guide) and channel changing functions. For the VPX-UC1 Ultra it can go a step further and control the Android inside the unit as a 6-axis gyroscope to move the on-screen mouse and control other Android functions. The IRC-BT1 also has a high-fidelity microphone for voice commands with Google Voice Assistant when enabled on the VPX-UC1 Ultra Android setup.\n\nAnother advanced feature is the button pass-through mode, where the IRC-BT1 button presses and releases will be sent through the VPX over to a 3rd party control system for the controller to decide what to do as a result of the action. This allows for the remote to be used to control anything in the room the 3rd party controller has access to. Lighting, screen up/down, display power and more can now be easily controlled without line of sight thanks to its 2.4GHz wireless operation. For dim rooms, the IRC-BT1 has blue backlighting and requires only 2 AAA batteries.",
  features: [
    "RF 2.4GHz",
    "IR",
    "6 Axis Gyro Mouse",
    "Backlit Buttons"
  ],
  images: ["/lovable-uploads/dea779a6-e575-4fdf-a2a5-13dd3f221755.png"],
  slug: "irc-bt1",
  networkSpeed: "vpx-accessories"
};
